export const TITLE = 'Coronavirus';
export const DESCRIPTION = '(Covid-19) Vaccination';
export const DB_PREFIX = 'covid';
export const DB_PREFIX_VACCINATED = 'isCovidVaccinated';
